import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TrainersModel } from 'common/models/page-models/Trainers Model/trainers-data.model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { TrainersFormWidgetService } from 'common/widget/Trainers/trainers-form-widget.services';

@Injectable({
    providedIn: 'root'
})
export class TrainersFormResolver extends FormResolverService<TrainersModel> {
    constructor(
        protected fs: TrainersFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}
